const NVC_CODE_ARR = [400, 600]

export default {
  namespaced: true,
  state: {
    showSlideVerify: false,
    prasieCb: null
  },
  getters: {
    showSlideVerify: state => state.showSlideVerify
  },
  mutations: {
    handleToggleSlideVerify (state, { status = true, action = null }) {
      state.showSlideVerify = status
      if (!status && action !== 'success') {
        state.prasieCb && state.prasieCb()
        state.prasieCb = null
      }
    },
    savePrasieCb (state, prasieCb) {
      state.prasieCb = prasieCb
    }
  },
  actions: {
    async handleVerify ({ commit }, { praiseResult, prasieCb = null } = {}) {
      return new Promise(resolve => {
        const { code } = praiseResult
        const needShowNvc = NVC_CODE_ARR.includes(code)
        if (needShowNvc) {
          commit('handleToggleSlideVerify', { status: true })
          commit('savePrasieCb', prasieCb)
          // 唤醒滑动验证
          window.getNC().then(() => {
            window.NoCaptcha.on('error', () => {
              window.console.log('error')
              resolve(false)
              return false
            })
            window.NoCaptcha.on('fail', () => {
              window.console.log('fail')
              resolve(false)
              return false
            })
            window.NoCaptcha.on('refresh', () => {
              window.console.log('refresh')
              window._nvc_nc.reset()
            })
            window.NoCaptcha.on('success', () => {
              commit('handleToggleSlideVerify', { status: false, action: 'success' })
              window.console.log('success')
              resolve(true)
              window.nvcReset()
              return true
            })
            window.NoCaptcha.upLang('cn', {
              LOADING: '加载中...', // 加载
              SLIDER_LABEL: '请向右滑动验证', // 等待滑动
              CHECK_Y: '验证通过', // 通过
              ERROR_TITLE: '非常抱歉，这出错了...', // 拦截
              CHECK_N: '验证未通过', // 准备唤醒二次验证
              OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码', // 二次验证
              TIPS_TITLE: '验证码错误，请重新输入' // 验证码输错时的提示
            })
            window._nvc_nc.reset()
          })
        } else if (code === 900) {
          window.nvcReset()
          return false
        } else {
          return resolve(code === 200)
        }
      })
    }
  }
}
